define(
	'BTM.ChangesRequestedbyAlight.ChangesRequestedbyAlight', [
		'Tracker', 'GoogleTagManager', 'underscore', 'jQuery', 'Backbone', 'SC.Configuration'
	],
	function (Tracker, GoogleTagManager, _, jQuery, Backbone, Configuration) {
		'use strict';


		var categories = {
			"": ""
		};

		function fetchCategory(data, haystack) {
			if (haystack) {
				if (!data) {
					data = {};
				}
				for (var i = 0; i < haystack.length; i++) {
					data[haystack[i].fullurl] = haystack[i].name;
					if (haystack[i].categories && haystack[i].categories.length > 0) {
						fetchCategory(data, haystack[i].categories);
					}
				}
			}
		}

		return {
			mountToApp: function mountToApp(container) {

				// Fetch all Item category
				fetchCategory(categories, SC.CATEGORIES);

				_.extend(GoogleTagManager, {
					// @method trackProductClick
					// @param {Object} item
					// @return {GoogleTagManager}
					trackProductClick: function (item) {
						var categoryName = item.get('category');
						var querySignIndex = categoryName.indexOf("?");
						if (querySignIndex > 0) {
							categoryName = categoryName.substring(0, querySignIndex);
						}
						categoryName = categories[categoryName] ? categories[categoryName] : "";

						var eventName = 'productClick';
						var eventData = {
							event: eventName,
							ecommerce: {
								click: {
									actionField: {
										list: categoryName
									},
									products: [{
										name: item.get('name'),
										price: ("" + item.get('price')).replace(/[^\d.-]/g, ''),
										sku: item.get('sku', true) + "",
										id: item.get('sku', true),
										category: item.get('category'),
										position: item.get('position')
									}]
								}
							}
						};

						// We set this item in this Tracker to later be read it by the trackProductView event
						this.item = item;
						// Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
						this.pushData(eventData);
						Tracker.trigger(eventName, eventData, item);

						return this;
					},

					// @method trackProductView
					// @param {Product.Model} product
					// @return {GoogleTagManager}
					trackProductView: function (product) {
						var item = product.getItem();

						if (this.item && this.item.get('itemId') === item.get('_id')) {
							item.set('category', this.item.get('category'), {
								silent: true
							});
							item.set('list', this.item.get('list'), {
								silent: true
							});
						}

						const eventName = 'productView';
						const selected_options = product.get('options').filter(function (option) {
							return option.get('value') && option.get('value').label;
						});
						const price = product.getPrice();
						const result = this.findCategoryAndListInDataLayer(product);

						var categoryName = item.get('category') || (result ? result.category : '');
						var querySignIndex = categoryName.indexOf("?");
						if (querySignIndex > 0) {
							categoryName = categoryName.substring(0, querySignIndex);
						}
						categoryName = categories[categoryName] ? categories[categoryName] : "";

						const eventData = {
							event: eventName,
							ecommerce: {
								detail: {
									actionField: {
										list: categoryName //item.get('list') || (result ? result.list : '')
									},
									products: [{
										name: item.get('_name'),
										sku: product.getSku() + "",
										id: product.getSku(),
										category: item.get('category') || (result ? result.category : ''), // as we do not support categories this is just the url
										variant: _.map(selected_options, function (option) {
											return option.get('value').label;
										}).join(', '),
										price: ("" + (price.price ? price.price : 0).toFixed(2)).replace(/[^\d.-]/g, '')
									}]
								}
							},
							page: this.getCategory()
						};

						this.item = null;

						// Triggers a Backbone.Event so others can subscribe to this event and add/replace data before is send it to Google Tag Manager
						Tracker.trigger(eventName, eventData, item);
						this.pushData(eventData);

						return this;
					}
				});


				if (SC.ENVIRONMENT && SC.ENVIRONMENT.GTM_DATALAYER && SC.ENVIRONMENT.GTM_DATALAYER.events && SC.ENVIRONMENT.GTM_DATALAYER.events.length > 0) {
					//fetchCategory(categories, SC.CATEGORIES);
					var events = SC.ENVIRONMENT.GTM_DATALAYER.events;
					for (var i = 0; i < events.length; i++) {
						switch (events[i].event) {
							case "productClick":
								if (events[i].ecommerce &&
									events[i].ecommerce.click &&
									events[i].ecommerce.click.products &&
									events[i].ecommerce.click.products.length) {
									var product = events[i].ecommerce.click.products[0];
									var categoryName = product.category;
									var querySignIndex = categoryName.indexOf("?");
									if (querySignIndex > 0) {
										categoryName = categoryName.substring(0, querySignIndex);
									}
									categoryName = categories[categoryName] ? categories[categoryName] : "";
									product.price = ("" + product.price).replace(/[^\d.-]/g, '');
									product.sku = "" + product.sku;
									events[i].ecommerce.click.actionField.list = categoryName;
								}
								break;
							case "productView":
								if (events[i].ecommerce &&
									events[i].ecommerce.detail &&
									events[i].ecommerce.detail.products &&
									events[i].ecommerce.detail.products.length) {
									var product = events[i].ecommerce.detail.products[0];
									var categoryName = product.category;
									var querySignIndex = categoryName.indexOf("?");
									if (querySignIndex > 0) {
										categoryName = categoryName.substring(0, querySignIndex);
									}
									categoryName = categories[categoryName] ? categories[categoryName] : "";
									product.price = ("" + product.price).replace(/[^\d.-]/g, '');
									product.sku = "" + product.sku;
									events[i].ecommerce.detail.actionField.list = categoryName;
								}
								break;
							default:
								break;
						}
					}
				}
			}
		};
	});
